"use strict";

const FilterSummary = function ($container, treePath, filterFields = [], onlyRenderOnTabs = null) {
  let disabled;
  let modifiedFilters;
  let needToRender;
  let keyToFieldDefinitionMap;

  const setFieldDefinitionMap = function (filterFields) {
    keyToFieldDefinitionMap = new Map();

    for (const fieldKey of filterFields) {
      const fieldDef = FilterFieldConstants.getFieldDefinition(fieldKey);
      if (fieldDef) {
        const actualKey = fieldDef.key || fieldKey;
        keyToFieldDefinitionMap.set(actualKey, fieldDef);
      }
    }

    _filtersUpdated();
  };

  const enable = function ({ force = false } = {}) {
    disabled = false;
    if (force) needToRender = true;
    render();
  };

  const _getCurrentContainer = function () {
    return $container.filter(":visible").first();
  };

  const render = function () {
    if (disabled || !needToRender || filterFields.length === 0) {
      return;
    }

    const bubbles = _getBubbleData();
    const html = nunjucks.render("filters/filterSummary.njk", { bubbles });
    $container.css("display", "flex").html(html);
    handleShowMore();
  };

  const handleShowMore = function () {
    const hide = DomFunctions.elementsHaveSameTop(_getCurrentContainer().find(".oval:visible"));

    $container.find(".bubbles-show-more").toggleClass("hidden", hide);

    if (hide) {
      toggleExpanded(false);
    }
  };

  const disable = function () {
    disabled = true;
    _clearBubbles();
  };

  const loadListeners = function () {
    $container.on("click", ".remove-filter", onClickRemoveFilter);
    $container.on("click", ".bubbles-show-more", toggleExpanded);

    Tree.select(treePath).off("update", _filtersUpdated).on("update", _filtersUpdated);
    Tree.watch({
      activeTab: ["activeTab"],
      navToggleSelection: ["navToggleSelection"],
      factSheet: ["factSheet", "open"],
      dataView: ["dataView"],
    }).on("update", tabUpdate);
  };

  const _filtersUpdated = function () {
    needToRender = true;
    render();
  };

  const tabUpdate = function () {
    const filtersDisabled = DataViewFunctions.getCurrentDataViewProperty("filterBarHiddenButtons");
    const enableSummary = DataViewFunctions.getCurrentDataViewProperty(
      "enableFilterSummaryOnMapOrListToggle",
    );
    const activeTab = Tree.get("activeTab");
    const factSheetOpen = Tree.get(["factSheet", "open"]);

    if (
      (!filtersDisabled || !filtersDisabled.includes("filter")) &&
      (!onlyRenderOnTabs || onlyRenderOnTabs.includes(activeTab)) &&
      factSheetOpen !== true &&
      enableSummary !== false
    ) {
      enable({ force: true });
    } else {
      disable();
    }
  };

  const areAllCheckboxesChecked = function (name) {
    var checkboxes = $('input[name="' + name + '"]');
    var checkedCheckboxes = $('input[name="' + name + '"]:checked');
    return checkboxes.length === checkedCheckboxes.length;
  };

  const toggleExpanded = function (expand = !_getCurrentContainer().hasClass("expanded")) {
    $container.toggleClass("expanded", expand);
  };

  const _clearBubbles = function () {
    $container.hide().html("");
  };

  const onClickRemoveFilter = function () {
    const dataKey = $(this).closest(".oval").data("key");

    _clearFilter(dataKey);
  };

  const _getBubbleData = function () {
    modifiedFilters = _getSelected();

    return [...getStandardBubbles()].filter(Boolean);
  };

  const getDateRange = function (key) {
    const { from, to, noDate } = modifiedFilters[key];

    if (!from && !to && !noDate) {
      return null;
    }

    return {
      from: from || null,
      to: to || null,
      noDate: noDate || null,
    };
  };

  const getMinMax = function (key) {
    const { min, max } = modifiedFilters[key];

    if (!min && !max) {
      return null;
    }

    return {
      min: min || null,
      max: max || null,
    };
  };

  const getMeasurementMinMax = function (key) {
    let { min, max, unit } = modifiedFilters[key];

    if (!min && !max) {
      return null;
    }

    min = unit === "in" ? min * 12 : min;
    max = unit === "in" ? max * 12 : max;

    const isEnabled =
      MeasurementMinMax.measurementRangeIsSet(modifiedFilters?.diameterRange) ||
      MeasurementMinMax.measurementRangeIsSet(modifiedFilters?.lengthRange) ||
      MeasurementMinMax.measurementRangeIsSet(modifiedFilters?.widthRange);

    return {
      min: min || null,
      max: max || null,
      unit: unit || null,
      isEnabled: isEnabled,
    };
  };

  const getStandardBubbles = function () {
    const bubbles = [];

    for (const key of keyToFieldDefinitionMap.keys()) {
      const definition = keyToFieldDefinitionMap.get(key);

      if (!dataIsChanged(definition, key)) {
        continue;
      }

      var bubble = {
        name: key,
        displayName: definition.displayName,
        count: 1,
        checked: null,
        selectedDisplayOptions: getSelectedDisplayOptions(key),
        minMax: getMinMax(key),
        measurementMinMax: getMeasurementMinMax(key),
        dateRange: getDateRange(key),
      };

      if (Array.isArray(modifiedFilters[key])) {
        bubble.count = modifiedFilters[key].length;
        bubble.checked = modifiedFilters[key];
      }

      bubbles.push(bubble);
    }

    return bubbles;
  };

  const dataIsChanged = function (definition, key) {
    const modified = modifiedFilters[key];

    if (definition.type === "multipleSelect") {
      const compareTo = keyToFieldDefinitionMap.get(key)?.options.map((opt) => opt.value);
      return modified && compareTo && !Misc.deepLooselyEqual(modified, compareTo);
    } else if (definition.type === "dateRange") {
      return modified && getDateRange(key) !== null;
    } else if (definition.type === "minMax" || definition.type === "measurementMinMax") {
      return modified && getMinMax(key) !== null;
    } else {
      throw new Error(`Unknown filter type: ${definition.type}`);
    }
  };

  const getSelectedDisplayOptions = function (key) {
    const selectedValues = modifiedFilters[key];
    if (!Array.isArray(selectedValues)) {
      return [];
    }

    const fieldDef = keyToFieldDefinitionMap.get(key);
    if (!fieldDef?.options) {
      return [];
    }

    return selectedValues.map((value) => fieldDef.options.find((opt) => opt.value === value)?.name);
  };

  const _clearFilter = function (key) {
    Tree.set([treePath, key], null);
    colorFilterButton();
    _hideCatchmentTableShowFilterPanel();
  };

  const _hideCatchmentTableShowFilterPanel = function () {
    $("#bottomFloatingInputsTable").addClass("hidden");
    $(".filter-menu").addClass("filter-full-height");
    Filters.showFilterMenu();
  };

  const colorFilterButton = function () {
    var $filterButton = $(".filter-button");
    $filterButton.addClass("invert-colors");
  };

  const _getSelected = function () {
    return Tree.get(treePath) ?? {};
  };

  loadListeners();
  setFieldDefinitionMap(filterFields);

  return {
    enable,
    disable,
    render,
    handleShowMore,
    toggleExpanded,
    areAllCheckboxesChecked,
    setFieldDefinitionMap,
    tabUpdate,
    _getSelected,
    _getBubbleData,
    _clearFilter,
    _clearBubbles,
  };
};

module.exports = FilterSummary;

const Filters = require("../mapFunctions/filters");
const Tree = require("../tree");
const DomFunctions = require("../general/domFunctions");
const MeasurementMinMax = require("../general/measurementMinMax");
const FilterFieldConstants = require("../config/filterFieldConstants");
const Misc = require("../misc");
const DataViewFunctions = require("../dataViewFunctions");
